import { tenant } from '../../config/tenant';

/** Número do WhatsApp comercial (somente dígitos, com DDI). */
export const whatsappNumber = (): string =>
	tenant.contacts.whatsappNumber ?? tenant.contacts.phone.replace(/\D/g, '');

/** Número formatado para exibição. */
export const whatsappFormatted = (): string =>
	tenant.contacts.whatsappFormatted ?? tenant.contacts.proneFormatted;

/** Monta um link wa.me com mensagem opcional. */
export const whatsappLink = (text?: string): string => {
	const base = `https://wa.me/${whatsappNumber()}`;
	return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};

export const WHATSAPP_MESSAGES = {
	info: `Olá! Gostaria de obter mais informações sobre o ${tenant.appName}.`,
	access: `Olá! Gostaria de saber como cadastrar minha empresa e acessar as oportunidades do ${tenant.appName}.`,
};
